import React, {Component} from "react";
import Dialog from '@mui/material/Dialog';
import {DialogActions} from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import withStyles from "@mui/styles/withStyles";

const styles = {
    video: {
        //position: "fixed",
        //right: 0,
        //top: 0,
        width: "100%",
        //height: "90vh",
        background: "black",
        // [theme.breakpoints.down(780)]: {
        //     display: 'none'
        // },
        // '@media(orientation: portrait)': {
        //     height: "40vh",
        // }
    }
};

class HowItWorks extends Component {

    constructor(props) {
        super(props);
        this.videoRef = React.createRef();
        this.listen = false;
    }

    componentDidMount() {
        if (this.props.open) {
            setTimeout(this.addListener.bind(this), 5000);
        }
    }

    componentWillUnmount() {
        this.removeListener();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.open) {
            setTimeout(this.addListener.bind(this), 1000);
        } else {
            this.removeListener();
        }
    }

    addListener() {
        if (this.videoRef.current) {
            this.videoRef.current.addEventListener('ended', this.props.closeHandle, false);
        }
    }

    removeListener() {
        if (this.videoRef.current) {
            this.videoRef.current.removeEventListener('ended', this.props.closeHandle);
        }
    }

    render() {
        const {classes} = this.props;
        return (
            <Dialog aria-labelledby="How It Works" open={this.props.open} onBackdropClick={this.props.closeHandle}
                    fullScreen>
                <DialogContent style={{display: "flex"}}>
                    <video controls autoPlay disablePictureInPicture ref={this.videoRef}
                           className={classes.video}>
                        <source src="/videos/default.mp4" type='video/mp4'/>
                        <source src="/videos/default.mp4" type="video/ogg"/>
                    </video>
                </DialogContent>
                <DialogActions>
                    <Button type="button" color="primary" variant="contained"
                            onClick={this.props.closeHandle}>Close</Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default withStyles(styles)(HowItWorks);
